import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';

import Booking from '../components/Booking';

const BookingScreen = () => {
  const { mooring_id: mooringIdParam, checkin: checkinParam } = useParams();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const from = searchParams.get('from');
  const to = searchParams.get('to');
  const boatLength = searchParams.get('l');
  const boatBeam = searchParams.get('b');
  const boatDraft = searchParams.get('d');

  return (
    <div className='auth-screen'>
      <Container className='bg-transparent'>
        <Row className='justify-content-center'>
          <Col xs={12} lg={10} xl={8} className='px-0 px-lg-3'>
            <Booking
              mooringId={mooringIdParam}
              from={from}
              to={to}
              boatLength={boatLength}
              boatBeam={boatBeam}
              boatDraft={boatDraft}
              checkin={Boolean(checkinParam)}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BookingScreen;
